/// <amd-module name="Build/Admin/Common/Sources/AgentCloudSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { TaskAgentCloud, TaskAgentCloudType } from "DistributedTask/Client/Contracts/TaskAgent";
import { getTaskAgentClient, ITaskAgentRestClient } from "DistributedTask/Client/RestClient/TaskAgent";

import { TaskAgentCloudsListData } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { DataProviders } from "Build/Admin/Common/Constants";

export class AgentCloudSource {
    private _client: ITaskAgentRestClient;
    private _pageContext: IVssPageContext;
    private _agentCloudsData: TaskAgentCloudsListData | undefined;
    private _agentCloudsDataInitialized: boolean;

    constructor(pageContext: IVssPageContext) {
        this._pageContext = pageContext;
        this._client = getTaskAgentClient(pageContext);
    }

    public getCachedAgentClouds(): TaskAgentCloud[] {
        this._initializeAgentCloudsData();
        if (this._agentCloudsData && this._agentCloudsData.taskAgentClouds) {
            return this._agentCloudsData.taskAgentClouds;
        }
        else {
            return [];
        }
    }

    public async getAgentCloud(agentCloudId: number): Promise<TaskAgentCloud> {
        return this._client.getAgentCloud(agentCloudId);
    }

    public async getAgentClouds(): Promise<TaskAgentCloud[]> {
        return this._client.getAgentClouds();
    }

    public async getAgentCloudTypes(): Promise<TaskAgentCloudType[]> {
        return this._client.getAgentCloudTypes();
    }

    public async addAgentCloud(agentCloud: TaskAgentCloud): Promise<TaskAgentCloud> {
        return this._client.addAgentCloud(agentCloud);
    }

    public async deleteAgentCloud(agentCloudId: number): Promise<TaskAgentCloud> {
        return this._client.deleteAgentCloud(agentCloudId);
    }

    private _initializeAgentCloudsData(): void {
        if (!this._agentCloudsDataInitialized) {
            const contributionService: IVssContributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
            this._agentCloudsData = contributionService.getData<TaskAgentCloudsListData>(DataProviders.AgentCloudsList);
            this._agentCloudsDataInitialized = true;
        }
    }
}
